import { Navigate, useParams } from "react-router-dom";
import { useGetUserQuery } from "../../query/usersQuery";
import { UserRole } from "@KassaroAB/shared/types/enums/UserRole";

interface AdminOrResellerGuardProps {
  children: React.ReactNode;
}

export const AdminOrResellerGuard = ({ children }: AdminOrResellerGuardProps) => {
  const { storeId } = useParams<{ storeId: string }>();
  const { data: user, isLoading } = useGetUserQuery();

  if (isLoading) {
    return null;
  }

  if (
    user?.role !== UserRole.ADMIN &&
    user?.role !== UserRole.RESELLER_ADMIN
  ) {
    return <Navigate to={`/stores/${storeId}/overview`} replace />;
  }

  return <>{children}</>;
};
